import React from 'react';

import { SVGComponentProps } from './svg.types';

const StrikethroughSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 13 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M11.3124 7.09998H6.5C5.07148 7.09998 3.95006 6.06948 3.95006 4.84995C3.95006 3.63054 5.07147 2.60004 6.5 2.60004C7.92853 2.60004 9.04994 3.63054 9.04994 4.84995C9.04994 5.34419 9.44425 5.75003 9.93752 5.75003C10.4307 5.75003 10.825 5.34417 10.825 4.84995C10.825 2.60445 8.87225 0.8 6.5 0.8C4.12775 0.8 2.17503 2.60445 2.17503 4.84995C2.17503 5.68282 2.44534 6.45692 2.90545 7.09998H1.68758C1.19436 7.09998 0.8 7.50564 0.8 7.99994C0.8 8.49418 1.19432 8.90002 1.68758 8.90002H6.5C7.92853 8.90002 9.04994 9.93052 9.04994 11.1499C9.04994 12.3695 7.92852 13.4 6.5 13.4C5.07148 13.4 3.95006 12.3695 3.95006 11.1499C3.95006 10.6556 3.5557 10.25 3.06248 10.25C2.56937 10.25 2.17503 10.6557 2.17503 11.1499C2.17503 13.3955 4.12775 15.2 6.5 15.2C8.87225 15.2 10.825 13.3955 10.825 11.1499C10.825 10.3172 10.5547 9.54307 10.0945 8.90002H11.3124C11.8057 8.90002 12.2 8.49418 12.2 7.99994C12.2 7.50564 11.8056 7.09998 11.3124 7.09998Z"
          fill={fill}
          stroke={fill}
          strokeWidth="0.4"
        />
      </svg>
    </span>
  );
};

export default StrikethroughSVG;
